import SemMarks from "./SemMarks";
import { useState } from "react";
import TNLogo from '../../../Constant/Icons/TamilNadu_Logo.png';
import back from '../../../Constant/Icons/back.svg';
import "./avgCalculator.css";

function AvgCalculator() {
  const [type, setType] = useState("");
  const [average, setAverage] = useState("");
  const [marks, setMarks] = useState({});
  const [errors, setErrors] = useState({});

  const semesterList = {
    Regular: ['SEMESTER 1', 'SEMESTER 2', 'SEMESTER 3', 'SEMESTER 4', 'SEMESTER 5', 'SEMESTER 6'],
    Lateral: ['SEMESTER 3', 'SEMESTER 4', 'SEMESTER 5', 'SEMESTER 6'],
    "Sandwich(7 Semesters)": ['SEMESTER 1', 'SEMESTER 2', 'SEMESTER 3', 'SEMESTER 4', 'SEMESTER 5', 'SEMESTER 6', 'SEMESTER 7'],
    "Sandwich(8 Semesters)": ['SEMESTER 1', 'SEMESTER 2', 'SEMESTER 3', 'SEMESTER 4', 'SEMESTER 5', 'SEMESTER 6', 'SEMESTER 7', 'SEMESTER 8'],
    "Sandwich(Lateral 7 Smesters)": ['SEMESTER 3', 'SEMESTER 4', 'SEMESTER 5', 'SEMESTER 6', 'SEMESTER 7'],
    "Sandwich(Lateral 8 Semesters)": ['SEMESTER 3', 'SEMESTER 4', 'SEMESTER 5', 'SEMESTER 6', 'SEMESTER 7', 'SEMESTER 8']
  };

  const handleTypeChange = (e) => {
    setType(e.target.value);
    setMarks({});
    setErrors({});
    setAverage("");
  };

  const handleMarkChange = (semester, field, value) => {
    setMarks((prev) => ({
      ...prev,
      [semester]: {
        ...prev[semester],
        [field]: value,
      },
    }));
    setErrors((prev) => ({
      ...prev,
      [semester]: {
        ...prev[semester],
        [field]: "",
      },
    }));
  };

  const calculateAverage = () => {
    let totalObtained = 0;
    let totalMax = 0;
    let newErrors = {};
    semesterList[type]?.forEach((sem) => {
      const obtained = marks[sem]?.obtained || "";
      const max = marks[sem]?.max || "";
      const numObtained = Number(obtained);
      const numMax = Number(max);

      newErrors[sem] = {};

      if (!obtained.trim()) {
        newErrors[sem].obtained = "Please fill this field.";
      } else if (isNaN(numObtained)) {
        newErrors[sem].obtained = "Enter valid number";
      }

      if (!max.trim()) {
        newErrors[sem].max = "Please fill this field.";
      } else if (isNaN(numMax)) {
        newErrors[sem].max = "Enter valid number";
      }

      if (!newErrors[sem].obtained || !newErrors[sem].max) {
        if (obtained <= 0) {
          newErrors[sem].obtained = "Invalid Mark..!";
        }
        if (max <= 0) {
          newErrors[sem].max = "Invalid Mark..!";
        }
      }

      if (!newErrors[sem].obtained && !newErrors[sem].max) {
        if (numObtained > numMax) {
          newErrors[sem].obtained = "Maximum marks should be greater then obtained marks";
        } else {
          totalObtained += numObtained;
          totalMax += numMax;
        }
      }

    });

    Object.keys(newErrors).forEach((sem) => {
      if (!newErrors[sem].obtained && !newErrors[sem].max) {
        delete newErrors[sem];
      }
    });

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      setAverage("");
      return;
    }

    const avg = totalObtained / totalMax * 100;

    const formatted = avg > 0 ? (Math.floor(avg * 10000) / 10000).toFixed(4) : 0;
    setAverage(formatted);
  };

  const handleReset = () => {
    setType("")
    setMarks({});
    setErrors({});
    setAverage("");
  };

  return (
    <div className="avg-calculator-wrapper home-page">
      <div className="header">
        <div className='logo'>
          <a href='https://tnlea.com'>
            <img alt='TN' src={TNLogo} width={50} height={50}></img>
          </a>
        </div>
        <div className='header-content'>
          <h3>GOVERNMENT OF TAMILNADU</h3>
          <h4>DIRECTORATE OF TECHNICAL EDUCATION</h4>
          <h4>Tamilnadu Lateral Entry Direct Second Year B.E/B.Tech., Admissions - 2025</h4>
        </div>
        <div className='profile'>
          <a href='/'>
            <img src={back} alt='Login' width={50} height={50} />
          </a>
        </div>
      </div>

      <div className="avg-calc-calculator-container">
        <form className="avg-calc-calculator-box" onSubmit={(e) => e.preventDefault()}>
          <h2>Average Calculator</h2>
          <select value={type} onChange={handleTypeChange} className="avg-calc-dropdown">
            <option value="">-- Select Student Type --</option>
            {Object.keys(semesterList).map((key) => (
              <option key={key} value={key}>{key}</option>
            ))}
          </select>

          {type && semesterList[type].map((sem) => (
            <SemMarks key={sem} semestername={sem} onChange={handleMarkChange} obtained={marks[sem]?.obtained || ""} max={marks[sem]?.max || ""} error={errors[sem] || {}}
            />
          ))}


          <div className="avg-calc-button-group ProceedButton">
            <button className="avg-calc-calculate-btn" type="button" onClick={calculateAverage}>Calculate</button>
            <button className="avg-calc-reset-btn" type="button" onClick={handleReset}>Reset</button>
          </div>

          <div className="avg-calc-average">
            <label>Average :</label>
            <input type="text" value={average ? `${average} %` : ""} disabled />
          </div>

        </form>
      </div>
    </div>
  );
}

export default AvgCalculator;
